// Full-page centered loader for route-level waits (auth bootstrap, OAuth
// callback, onboarding gate). For in-button loading use ButtonSpinner instead.
export function PageLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="page-loader">
      <div className="page-loader__spinner" role="status" aria-label={label} />
    </div>
  );
}
